// ATTN we use this constants in data dump
const abTests = {
  upchargeInfoPayment: 'UpchargeInfoPayment', // PF-1397
  homePlansV2: 'home:plansV2', // CRO-90
  homeVideoHero: 'home:videoHero', // CRO-107
  queueWidget: 'queueWidget', // CRO-40
  spQueueWidget: 'sp:queueWidget', // CRO-99
  tyNewUpgrade: 'ty:newUpgrade', // CRO-55
  tySubscriptionPromo: 'ty:subscriptionPromo', // CRO-59
  upgradeWithCase: 'upgradeWithCase', // CRO-57
  onlyCardUpdateModal: 'onlyCardUpdateModal', // CRO-96
  mainSpDashHudson: 'main:sp:dashHudson', // CRO-95
  registerFormAnimation: 'register:formAnimation', // CRO-112
  subscribePopupVisibility: 'subscribePopupVisibility', // CRO-97
  quizBrightButtons: 'quiz:brightButtons', // CRO-115
  paymentTextUnderPayButton: 'payment:textUnderPayButton', // CRO-109
  paymentAlwaysFreeCopy: 'payment:alwaysFreeCopy', // CRO-110
} as const

export type AbTestName = typeof abTests[keyof typeof abTests]


export default abTests
